import { useContext, useEffect, useMemo, useState} from "react";
import {useForm} from "react-hook-form";
import {useRecoilState} from "recoil";
import { rmfFilterParams } from "../contractor-main/model/state";
import SectionHeader from "../../../util/component/SectionHeader";
import {CONTRACTOR_SEARCH_INITIAL_VALUE} from "../contractor-main/utils/config";
import ContentBody from "../common/content-body/ContentBody";
import {IServerSideDatasource} from "ag-grid-community";
import {filterObject} from "../utils";
import {IContractorSearchForm} from "../contractor-main/model/model";
import {searchContractor} from "../contractor-main/service/contractorSearch.actions";
import ContractorFilter from "./partials/ContractorFilter";
import ContractorTable from "./partials/ContractorTable";
import { ISortBy } from "../../booking/api/types";
import { deepClone } from "../../../util/state/commonFunctions";
import { useMutation } from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import { GlobalContext } from "../../../util/state/GlobalContextProvider";

const OpenRoyaltiesFeesManagement = () => {
    const [filterExpanded, setFilterExpanded] = useState(false);
    const [filterParams, setFilterParams] = useRecoilState(rmfFilterParams);
    const rmfSearchListMutation = useMutation(searchContractor)
    const {globalData} = useContext(GlobalContext);

    const {t} = useTranslation(['network']);
    
    const searchContractorForm = useForm<IContractorSearchForm>({
        defaultValues: CONTRACTOR_SEARCH_INITIAL_VALUE
    });

    const handleSearch = (data: IContractorSearchForm) => {
        setFilterExpanded(false);
        setFilterParams(filterObject(data, x => JSON.stringify(data[x]) !== JSON.stringify(CONTRACTOR_SEARCH_INITIAL_VALUE[x])));
    }

    useEffect(() => {
            if (globalData.user.legalEntities.length === 1) {
                searchContractorForm.setValue('tenants', globalData.user.legalEntities);
            } else if (globalData.user.legalEntities.length > 1) {
                searchContractorForm.setValue('tenants', globalData.user.legalEntities.filter((elem: any) => elem.name !== 'all'));
                searchContractorForm.setValue('dealers', globalData.user.dealers.filter((elem: any) => elem.name !== 'all'));
            }
    
            const data = searchContractorForm.getValues();
            setFilterParams(filterObject(data, x => JSON.stringify(data[x]) !== JSON.stringify(CONTRACTOR_SEARCH_INITIAL_VALUE[x])));
        }, []);


    const serverSideDatasource: IServerSideDatasource = useMemo(() => ({
        getRows: async(params) => {
            let filterParamsClone = deepClone(filterParams);
            const sortBy: ISortBy | undefined = params.request.sortModel[0] ? {
                field: params.request.sortModel[0].colId,
                order: params.request.sortModel[0].sort
            } : undefined;

            const pagination = Number(params.request.endRow) - Number(params.request.startRow);

            if (!filterParamsClone) {
                filterParamsClone = {};
            }

            const {startRow: startIndex, endRow: endIndex} = params.request

            filterParamsClone['paramRequest'] = { pagination, sortBy, startIndex, endIndex };


            if (!!filterParamsClone.tenants) {
                const ind = filterParamsClone.tenants.findIndex((elem: any) => elem.name === 'all');
                if (ind > -1) {
                    filterParamsClone.tenants =
                        globalData.user.legalEntities
                            .filter((elem: any) => elem.name !== 'all')
                            .map((elem: any) => elem.name);
                } else {
                    filterParamsClone.tenants = filterParamsClone.tenants.map((elem: any) => elem.name);
                }
            }

            rmfSearchListMutation.mutateAsync(filterParamsClone)
                .then((response: any) => {
                    params.success({
                        rowData: response.contractor,
                        rowCount: response.params.totCount
                    });
                    response.params.totCount === 0 && params.api.showNoRowsOverlay();
                })
                .catch(() => {
                    params.fail();
                    params.api.hideOverlay();
                })                
        }
    }), [filterParams]);

    return (
        <>
            <SectionHeader title={t('contractorMng.title')}/>
            <ContentBody>
                <ContractorFilter
                    searchContractorForm={searchContractorForm}
                    handleSearch={handleSearch}
                    filterExpandedState={[filterExpanded, setFilterExpanded]}
                />
                <ContractorTable serverSideDatasource={serverSideDatasource} />
            </ContentBody>
        </>

    );
}

export default OpenRoyaltiesFeesManagement;
